import { useState, useEffect } from 'react';
import { LocalStorage, KEYS } from '@/utils/LocalStorage';

export const useHasRecommendation = (): boolean => {
  const [hasRecommendation, setHasRecommendation] = useState(false);

  useEffect(() => {
    const localBootupState = LocalStorage.getItem(KEYS.BOOTUP);

    if (localBootupState) {
      try {
        const parsedBootupState = JSON.parse(localBootupState);
        setHasRecommendation(parsedBootupState.recommendationExists ?? false);
      } catch (error) {
        console.error(
          'Failed to parse bootup state from local storage:',
          error,
        );
        setHasRecommendation(false);
      }
    }
  }, []);

  return hasRecommendation;
};
